import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// 成果转化 路由
const AchievementRoutes = [
  {
    path: '/',
    redirect: '/resultsAnalysis',
    component: () => import('@/views/layout/Layout.vue'),
    children: [
      {
        // 成果分析
        path: 'resultsAnalysis',
        name: 'resultsAnalysis',
        component: () => import('@/views/resultsAnalysis/index.vue'),
      },
      {
        // 成果分析详情
        path: 'resultsDetails',
        name: 'resultsDetails',
        component: () => import('@/views/resultsAnalysis/resultsDetails.vue'),
      },
      {
        // 需求分析
        path: 'requirementAnalysis',
        name: 'requirementAnalysis',
        component: () => import('@/views/requirementAnalysis/index.vue'),
      },
      {
        // 需求分析详情
        path: 'requirementDetails',
        name: 'requirementDetails',
        component: () => import('@/views/requirementAnalysis/requirementDetails.vue'),
      },
      {
        // 专家查询
        path: 'scholarSearch',
        name: 'scholarSearch',
        component: () => import('@/views/scholarSearch/index.vue'),
      },
      {
        // 专家查询历史记录
        path: 'scholarSearch/:id',
        name: 'scholarSearchHistory',
        component: () => import('@/views/scholarSearch/index.vue'),
      },
      {
        // 技术问答
        path: 'technicalQA',
        name: 'technicalQA',
        component: () => import('@/views/technicalQA/index.vue'),
      },
      {
        // 技术问答历史记录
        path: 'technicalQA/:id',
        name: 'technicalQAHistory',
        component: () => import('@/views/scholarSearch/index.vue'),
      },
      {
        // 历史记录
        path: 'historicRecords',
        name: 'historicRecords',
        component: () => import('@/views/historicRecords/index.vue'),
      },
      {
        // 文件管理
        path: 'fileManagement',
        name: 'fileManagement',
        component: () => import('@/views/system/fileManagement.vue'),
      },
      {
        // 机构详情
        path: 'orgDetail',
        name: 'orgDetail',
        component: () => import('@/views/org/orgDetail.vue'),
      },
      {
        // 专家详情
        path: 'talentDetail',
        name: 'talentDetail',
        component: () => import('@/views/details/talentDetail.vue'),
      },
      {
        // 论文详情
        path: 'paperDetail',
        name: 'paperDetail',
        component: () => import('@/views/details/paperDetail.vue'),
      },
      {
        // 专利详情
        path: 'patentDetail',
        name: 'patentDetail',
        component: () => import('@/views/details/patentDetail.vue'),
      },
      {
        // 项目详情
        path: 'projectDetail',
        name: 'projectDetail',
        component: () => import('@/views/details/projectDetail.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/system/login.vue'),
  },
  {
    path: '/registerApplication',
    name: 'registerApplication',
    component: () => import('@/views/system/registerApplication.vue'),
  },
  {
    path: '/notAccess',
    name: 'notAccess',
    component: () => import('@/views/system/NotAccess.vue'),
    hidden: true,
  },
  {
    path: '/*',
    name: '404',
    component: () => import('@/components/NotFound.vue'),
    hidden: true,
  },
]

// 国交 路由
const GuoJiaoRoutes = [
  {
    path: '/',
    redirect: '/resultsAnalysisGuoJiao',
    component: () => import('@/views/layout/LayoutGuoJiao.vue'),
    children: [
      {
        // 国交-成果分析
        path: 'resultsAnalysisGuoJiao',
        name: 'resultsAnalysisGuoJiao',
        component: () => import('@/views/GuoJiao/resultsAnalysis/index.vue'),
      },
      {
        // 国交-成果分析详情
        path: 'resultsDetailsGuoJiao',
        name: 'resultsDetailsGuoJiao',
        component: () => import('@/views/GuoJiao/resultsAnalysis/resultsDetails.vue'),
      },
      {
        // 国交-需求分析
        path: 'requirementAnalysisGuoJiao',
        name: 'requirementAnalysisGuoJiao',
        component: () => import('@/views/GuoJiao/requirementAnalysis/index.vue'),
      },
      {
        // 国交-需求分析详情
        path: 'requirementDetailsGuoJiao',
        name: 'requirementDetailsGuoJiao',
        component: () => import('@/views/GuoJiao/requirementAnalysis/requirementDetails.vue'),
      },
      {
        // 国交-历史记录
        path: 'historicRecordsGuoJiao',
        name: 'historicRecordsGuoJiao',
        component: () => import('@/views/GuoJiao/historicRecords/index.vue'),
      },
      {
        // 国交-文件管理
        path: 'fileManagementGuoJiao',
        name: 'fileManagementGuoJiao',
        component: () => import('@/views/system/fileManagementGuoJiao.vue'),
      },
      {
        // 国交-专家查询
        path: 'scholarSearchGuoJiao',
        name: 'scholarSearchGuoJiao',
        component: () => import('@/views/scholarSearchGuoJiao/index.vue'),
      },
      {
        // 国交-专家查询历史记录
        path: 'scholarSearchGuoJiao/:id',
        name: 'scholarSearchHistoryGuoJiao',
        component: () => import('@/views/scholarSearchGuoJiao/index.vue'),
      },
      {
        //  国交-专家详情
        path: 'talentDetailGuoJiao',
        name: 'talentDetailGuoJiao',
        component: () => import('@/views/details/talentDetail.vue'),
      },
      {
        // 国交-技术问答
        path: 'technicalQAGuoJiao',
        name: 'technicalQAGuoJiao',
        component: () => import('@/views/technicalQA/index.vue'),
      },
      {
        // 国交-技术问答历史记录
        path: 'technicalQAGuoJiao/:id',
        name: 'technicalQAHistoryGuoJiao',
        component: () => import('@/views/scholarSearchGuoJiao/index.vue'),
      },
      {
        // 机构详情
        path: 'orgDetail',
        name: 'orgDetail',
        component: () => import('@/views/org/orgDetail.vue'),
      },
      {
        // 专家详情
        path: 'talentDetail',
        name: 'talentDetail',
        component: () => import('@/views/details/talentDetail.vue'),
      },
      {
        // 论文详情
        path: 'paperDetail',
        name: 'paperDetail',
        component: () => import('@/views/details/paperDetail.vue'),
      },
      {
        // 专利详情
        path: 'patentDetail',
        name: 'patentDetail',
        component: () => import('@/views/details/patentDetail.vue'),
      },
      {
        // 项目详情
        path: 'projectDetail',
        name: 'projectDetail',
        component: () => import('@/views/details/projectDetail.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/system/login.vue'),
  },
  {
    path: '/notAccess',
    name: 'notAccess',
    component: () => import('@/views/system/NotAccess.vue'),
    hidden: true,
  },
  {
    path: '/*',
    name: '404',
    component: () => import('@/components/NotFound.vue'),
    hidden: true,
  },
]

const routerBase = process.env.VUE_APP_PUBLIC_PATH || '/';

const router = new Router({
  base: routerBase,
  mode: 'history',
  routes: process.env.VUE_APP_NAME === 'guojiao' ? GuoJiaoRoutes : AchievementRoutes,
  // routes: GuoJiaoRoutes
});
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
router.afterEach(() => {
  window.scrollTo(0, 0);
});
export default router;
